import ANALYTIC_EVENTS from "@/feature-analytics/analytic-events.mjs";
import { GA4_APP_PLAY_GAME_EVENT } from "@/feature-analytics/google.mjs";
import { refs__PRIVATE as refs } from "@/feature-analytics/tracker.mjs";
import type {
  MatchEndCore,
  MatchLiveCore,
  MatchStartCore,
} from "@/game-fortnite/models/game-events.mjs";

let accountId: string;
let gameId: string;
let gameMode: string;

export async function onEnterFortniteGame(payload: MatchStartCore) {
  refs.gtag("event", GA4_APP_PLAY_GAME_EVENT, {
    ...(await refs.getIdentifyingInfo()),
    game: "fortnite",
  });

  accountId = payload.localPlayer?.accountId;
  gameId = payload.gameId;
  gameMode = payload.gameMode;

  return refs.trackEvent(ANALYTIC_EVENTS.FRT_START, {
    accountId: payload.localPlayer?.accountId,
    gameId: payload.gameId,
    gameMode: payload.gameMode,
  });
}

export function onExitFortniteGame(payload: MatchEndCore) {
  const inventory = payload.localPlayer?.inventory;
  return refs.trackEvent(ANALYTIC_EVENTS.FRT_END, {
    accountId: payload.localPlayer.accountId,
    gameId: payload.gameId,
    gameMode: payload.gameMode,
    damageHistory: payload.localPlayer.damageHistory,
    localShots: payload.localPlayer.localShots,
    localHits: payload.localPlayer.localHits,
    localHeadshots: payload.localPlayer.localHeadshots,
    localDamageDealt: payload.localPlayer.localDamageDealt,
    localDamageTaken: payload.localPlayer.localDamageTaken,
    aliveTime: payload.localPlayer.aliveTime,
    inventory,
  });
}

let sendInventoryTimeout: NodeJS.Timeout = null;
export function onFortniteMatchLive(payload: MatchLiveCore) {
  if (gameMode === "Playlist_VK_Play") return;
  if (sendInventoryTimeout !== null) return;

  sendInventoryTimeout = setTimeout(() => {
    sendInventoryTimeout = null;
  }, 60000);

  return refs.trackEvent(ANALYTIC_EVENTS.FORTNITE_INVENTORY, {
    accountId: accountId,
    gameId: gameId,
    gameMode: gameMode,
    inventory: payload.player_inventory.map((value) => ({
      name: value.name,
      rarity: value.rarity,
      quantity: value.quantity,
      slot: value.slot,
    })),
    surviveTime: payload.players[accountId].survive_time,
    killScore: payload.kill_score,
    assist: payload.assists,
    downScore: payload.down_score,
  });
}

export function onFortniteItemShare(payload) {
  refs.trackEvent(ANALYTIC_EVENTS.FORTNITE_ITEM_SHARE, payload);
}
